export enum LayoutTypes {
  DI = 'DI',
  DL_DI = 'DL_DI',
  DB = 'DB',
  DL_DB = 'DL_DB',
  DBI = 'DBI',
  DL_DBI = 'DL_DBI',
}

export enum BlockTypes {
  DESCRIPTION = 'description',
  IMAGE = 'image',
  DOCUMENTS_LIST = 'documentsList',
  BIOMARKERS = 'biomarkers',
}
